export const environment = {
  production: false,
  protocol: 'https://',
  server: 'test.bracelit.es/',
  //server: 'api.v5.bracelit.es/',
  apiUrl: 'api/v1/',
};

// Este es el archivo de configuración para el entorno de **desarrollo**. Se usa cuando ejecutas `ng serve` o `npm start`.